import nanostyled from 'nanostyled';

export const Container = nanostyled('div', {
  width: 'max-w-xl xl:max-w-2xl px-16 py-8',
  flex: null,
  base: 'w-full',
});
